import { useEffect } from 'react';

// MANAGERS
import { useAppDispatch } from '@Managers/Redux/Hooks';
import { getBalance, quitAction } from '@Managers/Redux/HttpState/HttpState';

// TYPES
import { EDelegatedPages, EPopClientMessageType, IPopClientMessage } from './UsePopClient.types';

import { TPopClientFeatures, TPopClientFeaturesList } from '@ConfigLoader/Configs';
import { EButtonEvents } from '@Managers/Events/ButtonEvents';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { setPopClient } from '@Managers/Redux/AppState/AppState';
import { isJsonString } from '@Tools/IsJSON';

export const UsePopClientWorld2Game = (): { w2gInit: typeof w2gInit } => {
    const dispatch = useAppDispatch();

    const w2gMappings: { [key: string]: Function } = {
        [EPopClientMessageType.BASIC_G2W_INITIALIZATION_RESPONSE]: (data: IPopClientMessage) => initializeResponseHandler(data),
        [EPopClientMessageType.AUTOPLAY_W2G_INTERRUPT_GAMEPLAY_COMMAND]: () => interruptGameplayHandler(),
        [EPopClientMessageType.PAUSE_W2G_PAUSE_COMMAND]: (data: IPopClientMessage) => gamePauseHandler(data),
        [EPopClientMessageType.DISPLAYSTATUS_W2G_VISIBILITY_CHANGE_NOTIFICATION]: (data: IPopClientMessage) => visibilityChangeHandler(data),
        [EPopClientMessageType.SOUND_W2G_SOUND_UPDATE_NOTIFICATION]: (data: IPopClientMessage) => soundUpdateHandler(data),
        [EPopClientMessageType.BALANCEREFRESH_W2G_REFRESH_BALANCE_COMMAND]: () => refreshBalanceHandler(),
        [EPopClientMessageType.CLOSEGAME_W2G_CLOSE_GAME_REQUEST]: () => closeGameHandler()
    };

    const arrayToObj = (
        data: Array<
            string | [TPopClientFeatures.OPEN_PAGE, { delegatePages: EDelegatedPages[] }] | [TPopClientFeatures.SOUND, { mute: boolean; level: number }]
        >
    ) => {
        let features = {} as TPopClientFeaturesList;
        data.forEach((item) => {
            if (typeof item === 'string') {
                features[item] = true;
            } else {
                features[item[0]] = item[1] as any;
            }
        });
        return features;
    };

    useEffect(() => {}, []);

    const w2gInit = () => {
        window.onmessage = (e) => {
            if (e.data && typeof e.data === 'string' && isJsonString(e.data)) {
                const data = JSON.parse(e.data) as IPopClientMessage;
                w2gMappings[data._type] != null ? w2gMappings[data._type](data) : console.warn('[GAME ERROR]: Undefined request');
            }
        };
    };

    const initializeResponseHandler = (data: IPopClientMessage) => {
        if (data.features) {
            const features = arrayToObj(data.features);
            dispatch(setPopClient({ enabled: true, initialized: true, supportedFeatures: features }));
            if (features.sound) soundUpdateHandler(features.sound);
        }
    };

    const interruptGameplayHandler = () => {
        EventsCenter.emit(EButtonEvents.AUTO_STOP_BUTTON_PRESSED);
    };

    const gamePauseHandler = (data: IPopClientMessage) => {
        if (data.pause) {
            EventsCenter.emit(EGameEvents.INITIATE_PAUSE);
        } else {
            EventsCenter.emit(EGameEvents.INITIATE_UNPAUSE);
        }
    };

    const visibilityChangeHandler = (data: IPopClientMessage) => {
        // TO DO
        console.log('visibilityChangeHandler');
    };

    const soundUpdateHandler = (data: Pick<IPopClientMessage, 'mute' | 'level'>) => {
        if (data.mute || data.level === 0) {
            EventsCenter.emit(EGameEvents.MUTE);
        } else {
            EventsCenter.emit(EGameEvents.UNMUTE);
        }
    };

    const refreshBalanceHandler = async () => {
        const response = await dispatch(getBalance());
        if (response.payload) {
            EventsCenter.emit(EGameEvents.REFRESH_BALANCE_RECEIVED, { account: response.payload });
        }
    };

    const closeGameHandler = () => {
        dispatch(quitAction());
    };

    return { w2gInit };
};
